'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.categories.add', [])
  .controller('CategoriesAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/categories/add/index.js